<template>
  <div class="btnCom" :style="{
                background: `url('${configImgUrl()}${config.background}')`
            }" @click="getbtnClick">
    <div :style="{
                textAlign:config.font.align,
               }">
      <span :style="{
                color:config.font.color,
                fontFamily:config.font.fontFamily,
                fontSize:config.font.fontSize +'px',
                fontWeight:config.font.fontWeight,
                lineHeight:trans.height +'px',
               }">
        {{config.font.centent}}</span>
    </div>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/5/17 4:58 下午
 */
import { pathFullScreen, pathShareScreen } from '@/assets/js/basis.js'
import {
  GetScreenPageIndexByID,
} from '@/assets/axios/createScreen/configScreen'
import {
  GetScreenLinkSharing
} from '@/assets/axios/createScreen/configScreen'
export default {
  name: 'btnCom',
  components: {},
  props: {
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default: ''
    },
    trans: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      clickedScreenID: "",
      captchaID: "",
    }
  },
  computed: {
    config() {
      if (this.type === 'view') {
        return this.$store.state.viewDP.chart.setting.params;
      } else if (this.type === 'screen') {
        return this.option.setting.params;
      }
    },
  },
  methods: {
    getbtnClick() {
      if (this.$route.path.indexOf('/fullScreen') !== -1) {
        pathFullScreen({
          id: this.config.push.url,
          type: 1
        })
      } else if (this.$route.path.indexOf('/shareScreen') !== -1) {
          pathShareScreen({
          id: this.config.push.url,
          type: 1
        })
      }
    },
    async enter2() {
      this.clickedScreenID = localStorage.getItem('clickedScreenID')
      this.captchaID = window.location.href.slice(-72, -36)
      this.show = false;
      await GetScreenLinkSharing({
        screenID: this.clickedScreenID,// 大屏ID
        captchaID: this.captchaID
      }).then(async res => {
        if (res.code === 200) {
          this.password = true;
          let node = res.data;
          document.getElementsByTagName('title')[0].innerHTML = node.screenPageName || '大屏预览页面';
          this.pageSize.width = node.sizeX || 0;
          this.pageSize.height = node.sizeY || 0;
          this.show = true;
          try {
            this.$nextTick(async () => {
              this.show = true;
              let pageParam = JSON.parse(node.screenJson);
              if (!pageParam.back.checkedVal1) {
                this.nextScreen = false;
              }
              this.nextScreen = pageParam.back.rotationID
              this.rotationTime = pageParam.back.rotationTime * 1000;
              let defaultVal = this.$store.state.designer.defaultVal;
              this.allData = JSON.parse(JSON.stringify(await this.getDGCopy(defaultVal.pageParam, pageParam)));
              let modu = modules;
              await this.$store.dispatch('screenAllRender', { modu, node });
              if (this.adapt) {
                await this.getInnerHeight('.screen_page_chart');
              }
            })
          } catch (e) {
            this.show = false;
          }
        }
      })
    },
  },
  mounted() {

  },
  destroyed() {

  }
}
</script>

<style lang="less">
.btnCom {
  cursor: pointer;
  background-size: 100% 100% !important;
}
</style>
